import axios from 'axios';
import { AppSettingsResponseSchema, type AppSettingsResponse } from '../schemas/apiResponse.schemas';
import { validateResponse } from './validateResponse';

const API_BASE = '/api/app-settings';

export async function fetchAppSettings(): Promise<AppSettingsResponse> {
  const response = await axios.get(API_BASE);
  return validateResponse(AppSettingsResponseSchema, response.data, 'fetchAppSettings');
}

export async function patchAppSettings(
  printClaimWindowMinutes: number,
): Promise<AppSettingsResponse> {
  const response = await axios.patch(API_BASE, {
    print_claim_window_minutes: printClaimWindowMinutes,
  });
  return validateResponse(AppSettingsResponseSchema, response.data, 'patchAppSettings');
}
